export enum ENTITY_TYPE {
  INDIVIDUAL = 'INDIVIDUAL_ENTITY',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  BOTH = 'BOTH'
}
